import { createSlice } from '@reduxjs/toolkit'

import client from 'api'
import { AppThunk } from 'store'

const initialState = {
    issueId: 0,
    notes: [] as any[],
    hasError: false,
}

const issueNotesSlice = createSlice({
    name: 'issue notes',
    initialState,
    reducers: {
        setNotes: (state, { payload }) => {
            state.hasError = false;
            state.issueId = payload.issueId
            state.notes = payload.notes
        },
        addNote: (state, action) => {
            state.hasError = false;
            state.notes = [...state.notes, action.payload]
        },
        setError: (state) => {
            state.hasError = true;
        }
    }
})

export const loadNotes = (issueId: number): AppThunk => async (dispatch) => {
    try {
        const res = await client.get(`/api/ixweb/nurismeldnotiz/?MIN_MELDUNGID=${issueId}&MAX_MELDUNGID=${issueId}`)
        dispatch(setNotes({
            issueId,
            notes: res.data
        }))
    } catch(e) {
        dispatch(setError())
    }
}

export const createNote = (note: any): AppThunk => async (dispatch, getState) => {
    try {
        // const { currentIssueNotes } = getState()
        const res = await client.post('/api/ixweb/nurismeldnotiz/', note)

        const { issueNotes } = getState()

        if (issueNotes.issueId === note.MELDUNGID) {
            dispatch(addNote(res.data))
        }
    } catch (e) {
        dispatch(setError())
    }
}

export const updateNote = (note: any): AppThunk => async (dispatch, getState) => {
    try {
        await client.put(`/api/ixweb/nurismeldnotiz/${note.HDR_ID}/`, note)

        const { issueNotes } = getState()
        if (note.MELDUNGID === issueNotes.issueId) {
            dispatch(loadNotes(issueNotes.issueId))
        }
    } catch(e) {
        dispatch(setError())
    }
}

export const deleteNote = (note: any): AppThunk => async (dispatch, getState) => {
    try {
        await client.delete(`/api/ixweb/nurismeldnotiz/${note.HDR_ID}/`)

        const { issueNotes } = getState()
        if (note.MELDUNGID === issueNotes.issueId) {
            dispatch(loadNotes(issueNotes.issueId))
        }
    } catch(e) {
        dispatch(setError())
    }
}

export const { setNotes, addNote, setError } = issueNotesSlice.actions
export default issueNotesSlice.reducer
